
import { Component, OnInit, ViewChild, Input, OnChanges, ElementRef, Renderer2, EventEmitter, Output } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { SVGIcon, fileExcelIcon, pencilIcon, trashIcon, downloadIcon, mapMarkerIcon, checkIcon } from '@progress/kendo-svg-icons';
import { process, State, FilterDescriptor } from '@progress/kendo-data-query';
import { GridModule } from '@progress/kendo-angular-grid';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ExcelExportModule, ExcelExportComponent } from "@progress/kendo-angular-excel-export";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { GridService } from 'app/services/grid.service';
import { Router } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { TranslocoPipe } from '@ngneat/transloco';
import { IntlService } from '@progress/kendo-angular-intl';
import { CheckBoxModule } from '@progress/kendo-angular-inputs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MapModule } from '@progress/kendo-angular-map';
import { SharedService } from '../../services/shared.service';
import { SharedModule } from '../../modules/shared.module';
import { AuthService } from '../../core/auth/auth.service';
import { DrakeSharedService } from '../../services/drake-shared.service';
import { environment } from 'environments/environment';

interface Option {
  value: string;
  text: string;
}

@Component({
  selector: 'app-drake-user',
  standalone: true,
  imports: [
    CommonModule,
    HttpClientModule,
    GridModule,
    ChartsModule,
    InputsModule,
    ButtonsModule,
    ExcelExportModule,
    MatToolbarModule,
    MatDialogModule,
    DropDownsModule,
    CheckBoxModule,
    MapModule,
    TranslocoPipe,
    SharedModule
  ],
  templateUrl: './drake-user.component.html',
  styleUrls: ['./drake-user.component.scss']
})
export class DrakeUserComponent implements OnInit, OnChanges {

  @Input() public userCode: string = '';
  public userData: any = {};
  public profilePic: string | null = null;

  constructor(
    private gridService: GridService,


  ) { }


  ngOnInit(): void {
    this.loadUser();
  }



  ngOnChanges(): void {
    if (this.userCode) {
      this.loadUser();
    }
  }



  loadUser(): void {
    if (!this.userCode) {
      return;
    }

    this.gridService.getScopeData("USERS", "READ", { viewCode: "USERS.PROFILE", filter: JSON.stringify({ _id: this.userCode }) }).subscribe(
      (userData: any) => {
        this.userData = userData.data[0];
        this.gridService.getImage(this.userData.ProfilePic?.dataUrl).subscribe((data:any) => this.profilePic = data.dataUrl);
      },
      (error) => {
        console.error('Errore durante il caricamento della configurazione della griglia', error);
      }
    );
  }

}

